<template>
<transition 
  name="c-imageModal"
  @after-leave="afterLeave"
>
  <div class="c-imageModal" v-show="isShowModal">
    <div class="c-imageModal__bg"></div>
    <a class="c-imageModal__close" href="#" role="button" @click.prevent="close">
      <img :src="`${$store.getters.assetsPath}img/common/icon-close.svg`" alt="" width="46" height="27">
    </a>
    <div class="c-imageModal__wrap">
      <div class="swiper">
        <div class="swiper-wrapper">
          <img 
            class="swiper-slide"
            alt="" 
            v-for="(src, i) in srcModal.images" 
            :key="src" 
            :src="`/collections/luxury/2023/assets/img/carousel/${srcModal.model}/original/${src}`" 
            :data-model="srcModal.model"
            :data-src="src"
            @load="imgloaded"
            >
        </div>
        <div class="swiper-ui">
          <div class="swiper-button-next" role="button"></div>
          <div class="swiper-button-prev" role="button"></div>
        </div>
      </div>

    </div>
  </div>
</transition>
</template>

<script>
import Swiper, { Navigation } from 'swiper';

export default {
  data() {
    return {
      resizeObserver: null,
      swiper: null,
      counter: 0,
      isStart: false,
    }
  },
  computed: {
    isShowModal() {
      return this.$store.getters.showModal;
    },
    srcModal() {
      return this.$store.getters.srcModal;
    }
  },
  mounted() {
  },
  methods: {
    close() {
      if (!this.isStart) return;
      this.$store.commit('setShowModal', false);
      this.isStart = false;
    },
    afterLeave() {
      // this.resizeObserver.unobserve(this.$el);
      // this.resizeObserver.disconnect();

      this.$store.commit('setSrcModal', {});

      // this.srcModal = null;
      this.swiper.destroy();
      this.swiper = null;
      this.counter = 0;
    },
    imgloaded(e) {
      this.counter++;
      if (this.counter >= this.srcModal.images.length) {
        this.$nextTick(this.start);
      }
    },
    start() {
      const el = this.$el.querySelector('.swiper');
      this.swiper = new Swiper(el, {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        speed: 500,
        loop: true,
        initialSlide: this.$store.getters.currentThumb,
        breakpoints: {
          901: {
            spaceBetween: 40
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init: function (e) {
            // console.log('swiper initialized', e);
          }
        },
      });

      this.isStart = true;
      
      // this.resizeObserver = new ResizeObserver(this.resize);
      // this.resizeObserver.observe(this.$el);
    },
    resize() {
      // this.close();
    }
  }
}
</script>